import React, { useEffect, useState } from 'react';
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import Constants from '../../utility/Constants';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const BetList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const userDetailState = useSelector((state) => state.userDetailState);
  const [state, setState] = useState({
    limit: 50,
    pageCount: null,
  });
  const [betHistory, setBetHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [loading_search, setLoading_search] = useState(false);

  if (!userDetailState.user_details) {
    navigate('/');
  }

  const loadTransactionList = async () => {
    const params = JSON.stringify({
      user_id: userDetailState?.user_details?.user_data?._id,
      game_id: "",
      provider_id: "",
      transaction_type: "",
      start_date: startDate,
      end_date: endDate,
      limit: state.limit.toString(),
      page: page.toString()
    });

    GeneralService.apiPostCallRequest(`${ApiURL.getTransactionList}`, params, userDetailState.user_details.token).then(res => {
      if (res.error === Constants.API_RESPONSE_ERROR_FALSE) {
        setLoading(false);
        setBetHistory(res.data.logs);
        setState(prevState => ({
          ...prevState,
          pageCount: res.data.pages,
        }));
      }
    }).catch(() => setLoading(false));
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    setPage(1);
    loadTransactionList();
  }, []);

  const handlePageClick = (data) => {
    const pagination = data.selected + 1;
    setPage(pagination);

    setState(prevState => ({
      ...prevState,
      pageCount: pagination
    }));

    const params = JSON.stringify({
      user_id: userDetailState?.user_details?.user_data?._id,
      game_id: "",
      provider_id: "",
      transaction_type: "",
      start_date: startDate,
      end_date: endDate,
      limit: state.limit.toString(),
      page: pagination.toString()
    });

    GeneralService.apiPostCallRequest(`${ApiURL.getTransactionList}`, params, userDetailState.user_details.token).then(res => {
      if (res.error === Constants.API_RESPONSE_ERROR_FALSE) {
        setLoading(false);
        setBetHistory(res.data.logs);
        setState(prevState => ({
          ...prevState,
          pageCount: res.data.pages,
        }));
      }
    }).catch(() => setLoading(false));
  };

  const SearchBetRecords = async () => {
    try {
      setLoading_search(true);
      setPage(1);

      const params = JSON.stringify({
        user_id: userDetailState?.user_details?.user_data?._id,
        game_id: "",
        provider_id: "",
        transaction_type: "",
        start_date: startDate,
        end_date: endDate,
        limit: state.limit.toString(),
        page: "1"
      });

      GeneralService.apiPostCallRequest(`${ApiURL.getTransactionList}`, params, userDetailState.user_details.token).then(res => {
        if (res.error === Constants.API_RESPONSE_ERROR_FALSE) {
          setLoading_search(false);
          setBetHistory(res.data.logs);
          setState(prevState => ({
            ...prevState,
            pageCount: res.data.pages,
          }));
        }
      }).catch(() => setLoading_search(false));
    } catch (error) {
      setLoading_search(false);
      console.error('Error fetching data:', error);
    }
  };

  return (
    <div>
      <style>{`
        .table-row-even { background-color: #0b1e3c; }
        .table-row-odd { background-color: #13294f; }
        .table tbody tr:hover { background-color: #1c3b66; }
        .pagination .page-item .page-link {
          background-color: #0b1e3c;
          color: #ffffff;
          border: 1px solid #1a3a6d;
          margin: 0 2px;
        }
        .pagination .page-item.active .page-link {
          background-color: #1e90ff;
          border-color: #1e90ff;
          color: white;
        }
        .pagination .page-item.disabled .page-link {
          background-color: #2b2b2b;
          color: #777;
        }
        .pagination .page-link:hover {
          background-color: #1c3b66;
          color: #fff;
        }
      `}</style>

      <div className='md-12' style={{ display: "flex", gap: "10px" }}>
        <div>
          <label style={{ color: "#fff" }}>Start Date:</label>
          <DatePicker
            className="date_sec form-control"
            showMonthDropdown
            showYearDropdown
            dateFormat="dd/MM/yyyy"
            dropdownMode="select"
            selected={startDate}
            wrapperClassName="datePicker"
            onChange={(date) => setStartDate(date)}
          />
        </div>

        <div>
          <label style={{ color: "#fff" }}>End Date:</label>
          <DatePicker
            className="date_sec form-control"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="dd/MM/yyyy"
            selected={endDate}
            wrapperClassName="datePicker"
            onChange={(date) => setEndDate(date)}
          />
        </div>

        <div style={{ padding: "23px 0px 0px 0px" }}>
          <button type="submit" disabled={loading_search} onClick={SearchBetRecords} className='btn btn-primary form-control'>
            {!loading_search ? "Search" : (
              <span className="spinner-border spinner-border-sm align-middle ms-2" role="status" aria-hidden="true"></span>
            )}
          </button>
        </div>
      </div>

      <div className='table-section' style={{ maxHeight: "716px", overflowY: "auto", marginTop: "10px"}}>
        <table className="table" style={{ color: "#fff" }}>
          <thead style={{ position: "sticky", top: 0, background: "#011842" }}>
            <tr>
              <th>External Transaction Id</th>
              <th>Provider Name</th>
              <th>Game Name</th>
              <th>Transaction Amount</th>
              <th>Transaction Type</th>
              <th>Available Balance</th>
              <th>Round Id</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {betHistory?.length > 0 ? betHistory.map((betData, betIndex) => (
              <tr key={betIndex} className={betIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd'}>
                <td>{betData.external_transaction_id}</td>
                <td>{betData.provider_name}</td>
                <td>{betData.game_name?.en}</td>
                <td>{betData.transaction_amount}</td>
                <td>
                  <span className={betData.transaction_type === 'Debit' ? "badge rounded-pill bg-danger" : "badge rounded-pill bg-success"}>
                    {betData.transaction_type}
                  </span>
                </td>
                <td>{betData.available_balance}</td>
                <td>{betData.round_id}</td>
                <td>{betData.created_at}</td>
              </tr>
            )) : (
              <tr><td colSpan="8" className="text-center">No transactions found</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="Next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={state.pageCount}
        previousLabel="< Previous"
        renderOnZeroPageCount={null}
        containerClassName={'pagination justify-content-end'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        previousClassName={'page-item'}
        previousLinkClassName={'page-link'}
        nextClassName={'page-item'}
        nextLinkClassName={'page-link'}
        breakClassName={'page-item'}
        breakLinkClassName={'page-link'}
        activeClassName={'active'}
      />
    </div>
  );
};

export default BetList;
